<script setup>
import ActionButton from '@/tiptap/extensions/components/ActionButton/src/index.vue'
import { extActionButtonProps } from '@/tiptap/extensions/components/ActionButton/src/props'

defineProps(extActionButtonProps)
</script>

<template>
  <ActionButton
    :editor="editor"
    :action="() => editor.chain().focus().toggleStrike().run()"
    :is-active="() => editor.isActive('strike') || false"
    :disabled="!editor.can().toggleStrike()"
    :tooltip="t('editor.strike.tooltip')"
    icon="strike"
  />
</template>
